var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThankful(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2050px",
    height: "2050px",
    viewBox: "0 0 2050 2050",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#ffc500;}.cls-3{fill:#ff9f1e;}.cls-4{fill:#ffe059;}.cls-5{fill:#00305f;}.cls-6{fill:#ff4f4f;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2040,
    width: 2040,
    x: 5,
    y: 5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 3",
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1025,
    cy: 1025,
    r: 613.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1068.5,1551.8c-339,0-613.7-274.8-613.7-613.7a613.5,613.5,0,0,1,44.4-229.8A610.7,610.7,0,0,0,411.3,1025c0,338.9,274.8,613.7,613.7,613.7,257.7,0,478.3-158.8,569.2-383.9C1486.8,1432.8,1291.5,1551.8,1068.5,1551.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1025,411.3A610.4,610.4,0,0,0,659.9,531.7a706.9,706.9,0,0,1,453.2-18.9,27.8,27.8,0,0,0-3.3,5.1c-18.2,33.9,18.9,89.1,82.7,123.3s130.4,34.6,148.6.8a38.6,38.6,0,0,0,3.7-10.5c165.2,128,271.9,328.1,272.9,553.1a613.3,613.3,0,0,0,21-159.6C1638.7,686.1,1363.9,411.3,1025,411.3Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1339.4,
    cy: 698.8,
    rx: 30.8,
    ry: 52.8,
    transform: "translate(396.9 1879.5) rotate(-79)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1235.1,
    cy: 718.7,
    rx: 17.2,
    ry: 25,
    transform: "translate(-4.9 1429) rotate(-60)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 821.8,
    cy: 930.1,
    rx: 94.9,
    ry: 60.2,
    transform: "translate(-143.1 1710.9) rotate(-87.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 851.5,
    cy: 891.5,
    r: 16.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1014.5,1334.6h-.1a30,30,0,0,1,0-60h.1c24.6,0,37.3-13.1,38.1-22.1.6-5.7-5.9-13.7-26.2-17.7a30,30,0,1,1,11.5-58.9c24.2,4.8,43.2,14.5,56.5,29.1s19.9,33.8,18,53.3-13.5,40.7-31.4,54.7S1039.9,1334.6,1014.5,1334.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1032.1,1235.4a30,30,0,0,1-5.7-59.5c12.7-2.4,27.1-8.6,26.2-17.7s-13.6-22.1-38.1-22.1h-.1a30,30,0,0,1,0-60h.1c25.4,0,48.4,7.5,66.5,21.7s29.4,33.9,31.4,54.6a68.4,68.4,0,0,1-18,53.3c-13.3,14.6-32.3,24.4-56.5,29.1A28.6,28.6,0,0,1,1032.1,1235.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1313.6,998.8a29.6,29.6,0,0,1-19.1-6.9h0c-.6-.5-63.7-51.8-122.1-42.6a29.7,29.7,0,0,1-29.1-12.2,30,30,0,0,1-2-31.6c29.6-55.1,73.3-75.7,104.7-83.3,33.3-8.1,59.8-3.4,62.7-2.9,30.7,15.6,17.3,61.6-11.2,59h.2A104.8,104.8,0,0,0,1258,881a98.9,98.9,0,0,0-28.5,12.7c56.9,14,100.8,50,103.3,52.1a30,30,0,0,1-19.2,53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1517.5,1058.3a82.8,82.8,0,0,0-116.9,0,82.8,82.8,0,0,0-117.7.8c-31.7,32.6-30.5,84.9,1.6,117.1l91,90.9a34.9,34.9,0,0,0,49.5,0l85.9-85.8q3.4-2.8,6.6-6A82.7,82.7,0,0,0,1517.5,1058.3Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankful);
export default __webpack_public_path__ + "static/media/thankful.4b8da439ef7d20d69cb687573fbb41af.svg";
export { ForwardRef as ReactComponent };